import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import useSessionGuard from 'hooks/useSession';
import AuthLoader from 'components/AuthLoader';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const result = useSessionGuard();
  
  // Extract the correct properties from the hook result
  const isAuthenticated = result.isLoggedIn ?? false;
  const isLoading = !(result.isInitialized ?? false);
  
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're not loading and not authenticated
    if (!isLoading && !isAuthenticated) {
      navigate('/auth/login', {
        state: { from: location.pathname },
        replace: true
      });
    }
  }, [isAuthenticated, isLoading, navigate, location]);

  // Show loading state while checking authentication
  if (isLoading) {
    return <AuthLoader />;
  }

  // Only render children if authenticated
  if (!isAuthenticated) {
    return null; // This prevents flash - redirect will happen in useEffect
  }

  // Render children only when authenticated
  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
